<script>
import LegoModalLayout from "@/views/Helexium/Lego/LegoModalLayout.vue";
import ModalHeaderControls from "@/components/Lego/ModalHeaderControls.vue";
import AddBtn from "@/components/buttons/AddBtn.vue";
import LegoQuill from "@/components/Lego/LegoQuill.vue";
import LegoModalCheckList from "@/components/Lego/LegoModalCheckList.vue";
import LegoModalComentarios from "@/components/Lego/LegoModalComentarios.vue";
import LegoModalDependents from "@/components/Lego/LegoModalDependents.vue";
import TourGuideLineal from "@/components/helexium/TourGuideLineal.vue";

export default {
  components: {
    LegoModalLayout,
    AddBtn,
    ModalHeaderControls,
    LegoQuill,
    LegoModalCheckList,
    LegoModalComentarios,
    LegoModalDependents,
    TourGuideLineal,
  },
  props: {
    boardId: {
      type: String,
      required: true,
    },
    cardId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeEditor: "",
      description: "",
      isLoading: true,
      isEditingTitle: false,
      editableTitle: "",
      // Visualización/edición de descripción
      isViewingDescription: true,
      showFullDescription: false,
      descriptionMaxHeightPx: 180,
    };
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    title() {
      return this.card?.title || "";
    },
    board() {
      return this.$store.state.lego.board;
    },
    column() {
      try {
        if (!this.board?.paginatedColumns?.items) {
          return {};
        }
        return (
          this.board.paginatedColumns.items.find(
            (column) => column.id === this.card.legoColumnId
          ) || {}
        );
      } catch {
        return {};
      }
    },
    card() {
      return this.$store.state.lego.card || {};
    },
    roleLevel() {
      return this.$store.state.lego.currencyRole?.level || 3;
    },

    canEditDescription() {
      return (this.$store.state.lego.currencyRole?.level || 3) <= 2;
    },

    canEditTitle() {
      return (this.$store.state.lego.currencyRole?.level || 3) <= 2;
    },

    hasLongDescription() {
      if (!this.description || this.description.trim() === "") return false;

      // Crear un elemento temporal para medir el contenido
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = this.description;
      tempDiv.style.position = "absolute";
      tempDiv.style.visibility = "hidden";
      tempDiv.style.width = "100%";
      tempDiv.style.lineHeight = "1.5";
      tempDiv.style.fontSize = "1rem";

      document.body.appendChild(tempDiv);

      const lineHeight = parseFloat(
        window.getComputedStyle(tempDiv).lineHeight
      );
      const height = tempDiv.offsetHeight;
      const lines = Math.ceil(height / lineHeight);

      document.body.removeChild(tempDiv);

      return lines > 6;
    },

    tourSteps() {
      const steps = [];
      steps.push({
        title: "Marcar Tarea como finalizada",
        description: "En este apartado podrás finalizar la tarea.",
        elementId: "TableroFinalizado",
      });
      if (this.roleLevel <= 2) {
        steps.push(
          {
            title: "Validar",
            description:
              "En este apartado podrás validar las tareas realizadas dentro del tablero.",
            elementId: "TableroValidar",
          },
          {
            title: "No conformidad",
            description:
              "En este apartado podrás agregar seleccionar un tipo de conformidad de acuerdo a la tarea.",
            elementId: "TableroAuditoria",
          },
          {
            title: "Calificación",
            description:
              "En este apartado podrás seleccionar si el tablero cumple o no.",
            elementId: "TableroAuditoriaCalificacion",
          }
        );
      }
      steps.push(
        {
          title: "Fecha de Inicio y se fin",
          description:
            "En este apartado podrás ingresar la fecha de inicio y de finalización de la tarea seleccionada.",
          elementId: "TableroFecha",
        },
        {
          title: "Nivel de esfuerzo",
          description:
            "En este apartado podrás ingresar que tanto esfuerzo requiere esta tarea.",
          elementId: "TableroEsfuerzo",
        },
        {
          title: "Adjuntar Archivos",
          description:
            "En este apartado podrás añadir archivos relacionados con la tarea.",
          elementId: "TableroAdjuntos",
        },
        {
          title: "Chat de colaboradores",
          description:
            "En este apartado podrás chatear con los colaboradores de la tarea.",
          elementId: "TableroChat",
        },
        {
          title: "Colaboradores",
          description:
            "En este apartado podrás visualizar los colaboradores de esta tarea.",
          elementId: "TableroColaboradores",
        },
        {
          title: "Titulo Tarjeta",
          description: "En este apartado podrás editar el nombre de la tarea.",
          elementId: "tituloTarjeta",
        },
        {
          title: "Descripción de la Tarjeta",
          description:
            "En este apartado podrás ingresar la descripción de la tarea para dar una indicación a los colaboradores.",
          elementId: "descripcionTarjeta",
        },
        {
          title: "Sub Tareas",
          description:
            "En este apartado podrás añadir Sub Tareas a la tarea principal.",
          elementId: "subTareas",
        },
        {
          title: "Sub Tareas Creadas",
          description: "En este apartado encontrarás las sub tareas creadas.",
          elementId: "subTareasCreadas",
        },
        {
          title: "Checklist Cumplimiento",
          description:
            "En este apartado podremos visualizar el porcentaje de cumplimiento de todas las checklist además de poder crear nuevas checklist.",
          elementId: "checklistTarea",
        },
        {
          title: "Porcentaje de cumplimiento",
          description:
            "En este apartado podrás visualizar el porcentaje de cumplimiento de cada Checklist.",
          elementId: "checklistTareaTotales0",
        },

        {
          title: "Detalle del Checklist",
          description:
            "Una vez creadas las checklist podremos visualizar y finalizar cada item y sub item de la checklist.",
          elementId: "checklistTareaTotalesDetalle0",
        },

        {
          title: "Añadir nuevo item de la Checklist",
          description:
            "En este apartado podremos agregar nuevos items a la checklist.",
          elementId: "addchecklistTareaTotales",
        },

        {
          title: "Comentarios Tarjeta",
          description:
            "En este apartado podremos agregar y visualizar comentarios en base a la tarea.",
          elementId: "comentariosTarjeta",
        }
      );
      return steps;
    },
  },
  watch: {
    title: {
      immediate: true,
      handler() {
        this.editableTitle = this.title;
        this.$nextTick(() => {
          const textarea = document.getElementById("tituloTarjeta");
          if (textarea) {
            this.autoResize({ target: textarea });
          }
        });
      },
    },
  },
  async mounted() {
    this.$isLoading(true);
    try {
      await this.initData();
      this.$watch(() => this.$route.params.cardId, this.initData);
      // Ajustar altura inicial del título si es necesario
      this.$nextTick(() => {
        const textarea = document.getElementById("tituloTarjeta");
        if (textarea) {
          this.autoResize({ target: textarea });
        }
      });
    } catch (error) {
      console.error("Error in mounted:", error);
    } finally {
      this.$isLoading(false);
    }
  },
  beforeDestroy() {
    // Limpiar el watcher cuando el componente se destruye
    if (this.$route.params.cardId) {
      this.$watch(() => this.$route.params.cardId, this.initData);
    }
  },
  methods: {
    async initData() {
      try {
        this.isLoading = true;
        await this.$store.dispatch("lego/getAndSetCard", this.cardId);
        this.description = this.card?.description || "";
        this.editableTitle = this.card?.title || "";
        // Pequeño delay para que la transición se vea más suave
        await new Promise((resolve) => setTimeout(resolve, 300));
      } catch (error) {
        console.error("Error loading card data:", error);
        this.description = "";
        // Mostrar un mensaje de error al usuario
        this.$vs.notify({
          title: "Error",
          text: "No se pudo cargar la tarjeta. Por favor, inténtalo de nuevo.",
          color: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    handleTitleInput(event) {
      if (!this.canEditTitle) return;
      this.editableTitle = event.target.value;
      this.autoResize(event);
    },

    handleTitleFocus() {
      if (!this.canEditTitle) return;
      this.isEditingTitle = true;
      this.$nextTick(() => {
        this.autoResize({ target: document.getElementById("tituloTarjeta") });
      });
    },
    async handleTitleBlur() {
      if (!this.canEditTitle) return;
      this.isEditingTitle = false;
      const title = this.editableTitle.trim();
      if (title) {
        await this.$store.dispatch("lego/setAsyncItemInCard", {
          ...this.card,
          title,
        });
      }
    },
    async saveTitle(ev) {
      if (!this.canEditTitle) return;
      if (ev.key === "Enter" && !ev.shiftKey) {
        ev.preventDefault();
        const title = this.editableTitle.trim();
        if (title) {
          await this.$store.dispatch("lego/setAsyncItemInCard", {
            ...this.card,
            title,
          });
        }
        ev.target.blur();
      }
    },
    autoResize(ev) {
      if (!this.canEditTitle) return;

      const textarea = ev.target;

      // Si no está en modo edición, ajustar al contenido pero máximo 3 líneas
      if (!this.isEditingTitle) {
        textarea.style.height = "auto";
        const maxHeight = Math.min(textarea.scrollHeight, 40 + 1.4 * 16 * 3);
        textarea.style.height = maxHeight + "px";
        return;
      }

      // En modo edición, ajustar al contenido sin límite
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    saveDescription() {
      const html = this.description.replace(
        /^(<p><br><\/p>)+|(<p><br><\/p>)+$/g,
        ""
      );
      this.$store.dispatch("lego/setItemInCard", { description: html });
    },
    nextAndSaveDescription(quill) {
      this.saveDescription();
      const next =
        quill.$el.parentElement.parentElement.nextElementSibling.querySelector(
          "button, input"
        );
      next.focus();
    },
    startTour() {
      this.$refs.tourGuide.startTour(this.tourSteps);
    },
    toggleShowFull() {
      this.showFullDescription = !this.showFullDescription;
      this.$nextTick(() => {
        // Forzar reflow para transiciones más suaves
        if (this.showFullDescription) {
          // Cuando se expande, esperar un poco para que la transición sea visible
          setTimeout(() => {
            const descView = document.querySelector(".description-view");
            if (descView) {
              descView.style.transition =
                "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)";
            }
          }, 50);
        }
      });
    },
  },
};
</script>

<template>
  <LegoModalLayout>
    <TourGuideLineal ref="tourGuide" />
    <template #header="{ close }">
      <header class="header">
        <ModalHeaderControls />
        <AddBtn class="close m-2" @click="close" />
      </header>
      <vs-button
        id="startButton"
        v-b-tooltip.hover
        title="Iniciar tutorial"
        circle
        icon
        danger
        relief
        @click.prevent="startTour"
      >
        <i class="far fa-circle-play mr-1"></i>
        Tutorial
      </vs-button>
    </template>
    <transition name="fade" mode="out-in">
      <div v-if="!isLoading" key="content" class="card-content">
        <transition name="slide-down" appear>
          <div class="title-wrapper">
            <textarea
              class="lego lego-input title custom-scrollbar"
              :class="{ 'is-editing': isEditingTitle }"
              :value="editableTitle"
              :readonly="!canEditTitle"
              @focus="handleTitleFocus"
              @blur="handleTitleBlur"
              @keydown.enter="saveTitle"
              @input="handleTitleInput"
              id="tituloTarjeta"
              style="animation-delay: 0.1s; resize: none"
              rows="1"
            ></textarea>
          </div>
        </transition>

        <transition name="slide-down" appear>
          <div
            class="item-card"
            id="descripcionTarjeta"
            style="animation-delay: 0.2s"
          >
            <div>
              <svg
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <line
                  x1="3"
                  y1="6"
                  x2="21"
                  y2="6"
                  stroke-linejoin="round"
                  stroke-width="2"
                ></line>
                <line
                  x1="3"
                  y1="10"
                  x2="21"
                  y2="10"
                  stroke-linejoin="round"
                  stroke-width="2"
                ></line>
                <line
                  x1="3"
                  y1="14"
                  x2="21"
                  y2="14"
                  stroke-linejoin="round"
                  stroke-width="2"
                ></line>
                <line
                  x1="3"
                  y1="18"
                  x2="14"
                  y2="18"
                  stroke-linejoin="round"
                  stroke-width="2"
                ></line>
              </svg>
            </div>
            <div class="in-right">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap"
              >
                <span class="title-section"> Descripción </span>
                <div v-if="canEditDescription" class="desc-actions">
                  <button
                    type="button"
                    class="link-btn"
                    @click="isViewingDescription = true"
                  >
                    <i
                      class="fas fa-eye"
                      :class="{ 'text-primary': isViewingDescription }"
                    ></i>
                  </button>
                  <span class="divider">·</span>
                  <button
                    type="button"
                    class="link-btn"
                    @click="isViewingDescription = false"
                  >
                    <i
                      class="fas fa-pencil-alt"
                      :class="{ 'text-primary': !isViewingDescription }"
                    ></i>
                  </button>
                </div>
              </div>
              <transition name="fade" mode="out-in">
                <!-- Vista HTML -->
                <div
                  v-if="!canEditDescription || isViewingDescription"
                  key="desc-view"
                  class="description-view"
                  :class="{
                    collapsed: hasLongDescription && !showFullDescription,
                  }"
                  :style="{ '--desc-max': descriptionMaxHeightPx + 'px' }"
                >
                  <div
                    class="description-html"
                    v-html="
                      description ||
                      '<p class=\'text-muted\'>Sin descripción</p>'
                    "
                  ></div>
                </div>
                <!-- Editor existente -->
                <LegoQuill
                  v-else
                  key="desc-edit"
                  @blur="saveDescription"
                  @ctrlEnter="saveDescription"
                  @tab="nextAndSaveDescription"
                  v-model="description"
                />
              </transition>
              <div
                v-if="
                  hasLongDescription &&
                  (!canEditDescription ||
                    (canEditDescription && isViewingDescription))
                "
                class="mt-2 d-flex align-items-center justify-content-center"
              >
                <button type="button" class="link-btn" @click="toggleShowFull">
                  {{ showFullDescription ? "Mostrar menos" : "Mostrar más" }}
                </button>
              </div>
            </div>
          </div>
        </transition>

        <transition name="slide-down" appear>
          <LegoModalDependents
            v-if="card.legoCardId == null && column && column.id"
            :color="column.color || '#ef476f'"
            style="animation-delay: 0.3s"
          />
        </transition>

        <transition name="slide-down" appear>
          <LegoModalCheckList
            :color="column && column.id ? column.color : '#ef476f'"
            style="animation-delay: 0.4s"
          />
        </transition>

        <transition name="slide-down" appear>
          <LegoModalComentarios
            id="comentariosTarjeta"
            style="animation-delay: 0.5s"
          />
        </transition>
      </div>
      <div v-else key="loading" class="loading-container">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p class="loading-text">Cargando tarjeta...</p>
        </div>
      </div>
    </transition>
  </LegoModalLayout>
</template>

<style scoped>
.header {
  margin-bottom: 1.5rem;
  border-bottom: solid 1px #cacaca;
  padding-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .dark & {
    border-bottom: solid 1px rgba(255, 255, 255, 0.25);
  }
}

.in-right {
  grid-column-start: 2;
  grid-column-end: none;
}

.title-wrapper {
  position: relative;
  margin-bottom: 0.8rem;
  overflow: hidden;
}

.title {
  border: none;
  font-size: 1.5rem;
  color: var(--text-progress) !important;
  padding: 8px 0;
  border-radius: 4px;
  width: 100%;
  white-space: pre-wrap;
  overflow: hidden;
  min-height: 24px !important;
  max-height: calc(1.4em * 3 + 16px); /* Máximo 3 líneas + padding */
  word-break: break-word;
  line-height: 1.4;
  background: transparent;
  resize: none;
  box-sizing: border-box;
  font-family: inherit;
  display: block;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0;
  text-overflow: clip;

  .dark & {
    background: transparent;
  }
}

.title.is-editing,
.title:focus {
  outline: none;
  height: auto;
  min-height: calc(1.4em * 3 + 16px);
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  padding: 8px;
  border-radius: 4px;

  .dark & {
    background: rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
}

.item-card {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.title-section {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  display: flex;
  gap: 0.5rem;
}

.desc-actions {
  display: inline-flex;
  gap: 0.25rem;
  margin-left: 0.5rem;
}

.description-view {
  position: relative;
  max-height: var(--desc-max, 180px);
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.description-view.collapsed {
  max-height: var(--desc-max, 180px);
}

.description-view:not(.collapsed) {
  max-height: 2000px;
}

/* Pseudo-elemento para crear un desvanecimiento más visible */
.description-view.collapsed::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(255, 255, 255, 0.1) 20%,
    rgba(255, 255, 255, 0.3) 40%,
    rgba(255, 255, 255, 0.7) 60%,
    rgba(255, 255, 255, 0.9) 80%,
    rgba(255, 255, 255, 1) 100%
  );
  pointer-events: none;
  z-index: 1;
}

/* Soporte para modo oscuro en el pseudo-elemento */
.dark .description-view.collapsed::after {
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(30, 32, 35, 0.1) 20%,
    rgba(30, 32, 35, 0.4) 40%,
    rgba(30, 32, 35, 0.7) 60%,
    rgba(30, 32, 35, 0.9) 80%,
    rgba(30, 32, 35, 1) 100%
  );
}

.description-html :deep(p) {
  margin-bottom: 0.75rem;
}

/* Desvanecido suave usando máscaras para no tapar el contenido */
.description-view.collapsed .description-html {
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 60%,
    rgba(0, 0, 0, 0.9) 70%,
    rgba(0, 0, 0, 0.7) 80%,
    rgba(0, 0, 0, 0.3) 90%,
    rgba(0, 0, 0, 0) 100%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 60%,
    rgba(0, 0, 0, 0.9) 70%,
    rgba(0, 0, 0, 0.7) 80%,
    rgba(0, 0, 0, 0.3) 90%,
    rgba(0, 0, 0, 0) 100%
  );
}

/* Soporte para modo oscuro en el desvanecimiento */
.dark .description-view.collapsed .description-html {
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 55%,
    rgba(255, 255, 255, 0.9) 65%,
    rgba(255, 255, 255, 0.7) 75%,
    rgba(255, 255, 255, 0.4) 85%,
    rgba(255, 255, 255, 0) 100%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 55%,
    rgba(255, 255, 255, 0.9) 65%,
    rgba(255, 255, 255, 0.7) 75%,
    rgba(255, 255, 255, 0.4) 85%,
    rgba(255, 255, 255, 0) 100%
  );
}

textarea.lego-input {
  min-height: 6rem !important;
  overflow: auto;
}

textarea.lego-input[readonly] {
  background-color: transparent;
  color: var(--text-progress);
  cursor: default;
  opacity: 1;
  -webkit-text-fill-color: var(--text-progress);
}

/* Botones tipo enlace */
.link-btn {
  background: transparent;
  border: none;
  color: var(--text-progress);
  padding: 0;
  font-size: 0.875rem;
  cursor: pointer;
}
.link-btn:hover,
.link-btn:focus {
  text-decoration: underline;
}
.desc-actions .divider {
  opacity: 0.5;
  margin: 0 0.25rem;
}

/* Transiciones */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* Slide down transition */
.slide-down-enter-active {
  transition: all 0.4s ease;
  transition-delay: inherit;
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}

.slide-down-leave-active {
  transition: all 0.2s ease;
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Loading container */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 2rem;
}

.loading-spinner {
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

.loading-text {
  color: var(--text-progress);
  font-size: 1rem;
  margin: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Dark mode support */
.dark .spinner {
  border-color: rgba(255, 255, 255, 0.2);
  border-top-color: #3498db;
}

.dark .loading-text {
  color: rgba(255, 255, 255, 0.8);
}
</style>
